import type { NewsCluster } from '../types/types';

/** Latest article date in the cluster (max `published_at`); backend does not order articles by date. */
export function getClusterMaxPublishedAt(cluster: NewsCluster): string | undefined {
  const articles = cluster.articles;
  if (!articles?.length) return undefined;
  let maxMs = -Infinity;
  let best: string | undefined;
  for (const a of articles) {
    const raw = a?.published_at;
    if (!raw) continue;
    const t = new Date(raw).getTime();
    if (!Number.isFinite(t)) continue;
    if (t > maxMs) {
      maxMs = t;
      best = raw;
    }
  }
  return best;
}

/** Milliseconds for sorting; missing or invalid dates sort last (ascending). */
export function getClusterMaxPublishedAtMs(cluster: NewsCluster): number {
  const raw = getClusterMaxPublishedAt(cluster);
  if (!raw) return Number.POSITIVE_INFINITY;
  const t = new Date(raw).getTime();
  return Number.isFinite(t) ? t : Number.POSITIVE_INFINITY;
}
